import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#ff6600',
                secondary: '#434343',
                accent: '#2dd700'
            },
            dark: {
                primary: '#ff6600',
                secondary: '#434343',
                accent: '#2dd700'
            }
        }
    }
});
